import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _ArrowDropDown(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "currentColor", d: "m11.808 14.77-3.715-4.458A.8.8 0 0 1 8.708 9h6.584a.8.8 0 0 1 .614 1.312l-3.714 4.458a.25.25 0 0 1-.384 0" })));
}
const ArrowDropDown = forwardRef(_ArrowDropDown);
export { ArrowDropDown };
